export default "__VITE_ASSET__DwxXlcHr__"